import React from 'react';

import _ from 'lodash';
import { Helmet } from 'react-helmet';
import { colorToString } from '../widgets/widget.helper';

function BrandThemeManager({ className, themes }) {
  if (_.size(themes) === 0) {
    return false;
  }

  return (
    <Helmet>
      {themes.map((theme, index) => {
        const format = _.get(theme, 'type');
        const fontSize = _.get(theme, 'font.fontSize');
        const fontFamily = _.get(theme, 'font.fontFamily');
        const color = _.get(theme, 'font.color');

        return (
          <style key={format}>
            {
              `${className} ${format} {
                font-size: ${fontSize}px;
                font-family: ${fontFamily};
                color: ${colorToString(color)};
              }`
            }
          </style>
        );
      })}
    </Helmet>
  );
}

export default BrandThemeManager;